import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'

export type ThemeMode = 'system' | 'light' | 'dark'

const storedTheme = localStorage.getItem('library-theme')

export const useThemeStore = defineStore('theme', () => {
  const mode = ref<ThemeMode>(storedTheme === 'light' || storedTheme === 'dark' ? storedTheme : 'system')
  const media = window.matchMedia('(prefers-color-scheme: dark)')
  const isDark = computed(() => mode.value === 'dark' || (mode.value === 'system' && media.matches))

  function apply(): void {
    document.documentElement.dataset.theme = isDark.value ? 'dark' : 'light'
    document.documentElement.style.colorScheme = isDark.value ? 'dark' : 'light'
  }

  function cycle(): void {
    mode.value = mode.value === 'system' ? 'light' : mode.value === 'light' ? 'dark' : 'system'
  }

  watch(mode, (value) => {
    localStorage.setItem('library-theme', value)
    apply()
  })
  media.addEventListener('change', apply)
  apply()

  return { mode, isDark, cycle }
})
